import React from "react";
import { SpaceLayout } from "../data";
import { SpaceLayoutListItem } from "./space_layout_list_item";
import { Grid } from "../components/grid";
import { Container } from "../components/container";
import { Pressable } from "../components/pressable";

interface SpaceLayoutPickerProps {
  value?: string | null;
  options: SpaceLayout[];
  onChange?: (value: string) => void;
  minCapacity?: number;
  withTestID: boolean;
}

export function displaySpaceLayout(layout: SpaceLayout) {
  return `${layout.name}`;
}

export function SpaceLayoutPicker(props: SpaceLayoutPickerProps) {
  const {
    minCapacity,
    value,
    withTestID,
    onChange = () => {},
    options,
  } = props;

  return (
    <Grid itemsPerRow={5}>
      {options
        .sort((a, b) => b.capacity - a.capacity)
        .map((option) => {
          const isSelected = option.id === value;

          const disabled = minCapacity ? option.capacity < minCapacity : false;

          return (
            <Container key={option.name} paddingBottom={16}>
              <Pressable
                testID={withTestID ? "layout-item" : undefined}
                disabled={disabled}
                onPress={() => {
                  onChange(option.id);
                }}
              >
                {({ hovered }) => (
                  <SpaceLayoutListItem
                    hovered={hovered}
                    disabled={disabled}
                    layout={option}
                    isSelected={isSelected}
                  />
                )}
              </Pressable>
            </Container>
          );
        })}
    </Grid>
  );
}
